export default __webpack_public_path__ + "834b40826b68fdf4d598599fa11d6c18.png";